// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = require("../../../../../node_modules/html-loader/dist/runtime/getUrl.js");
var ___HTML_LOADER_IMPORT_0___ = require("custom/images/warn.png");
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = " <div class=\"title\"> <p ng-bind=\"i18n('welcomeEmail.title')\"></p> </div> <div class=\"container\"> <div> <img src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"> <span class=\"errorMsg\" ng-bind=\"i18n('welcomeEmail.linkExpired')\"></span> </div> <div class=\"helpMsg\"> <span ng-bind=\"i18n('welcomeEmail.contactAdm')\"></span> </div> </div>";
// Exports
module.exports = code;


//////////////////
// WEBPACK FOOTER
// ./public/hws/js/welcomeemail/views/failedContent.html
// module id = 256
// module chunks = 0